// extracted by mini-css-extract-plugin
export default {"shipping-sub-title-main":"FreeShippingBanner_shipping-sub-title-main__nqryQ","shipping-sub-title":"FreeShippingBanner_shipping-sub-title__msbYq"};